import React from "react";
import styles from "./style.module.css";
import "./../commonStyle.css";
import HeadLines from "../CommonComponents/HeadLines";
import { location } from "../icon_assets";
import { isMobile } from "../helperFunc";
const TwoLineLocationWarehouse = (props) => {
  const {
    locationText1,
    locationText2,
    locationText1ClassName,
    locationText2ClassName,
    isCardBottomRounded = false,
    backGroundColor = true,
    className = "padding-left12 padding-right12 padding-top8 padding-bottom8 ",
    fontChange = false,
  } = props;
  return (
    <div
      className={`${
        backGroundColor ? styles["backGroundColor"] : ""
      } ${className} borderRadiusbottom  ${
        isCardBottomRounded && "borderRadiusBottom"
      }`}
    >
      <div
        className={`d-flex ${
          isMobile ? `align-items-start` : `align-items-center`
        }`}
      >
        <img
          src={location}
          width={!isMobile && 10}
          height={isMobile ? 12 : fontChange ? 17 : 15}
        />
        <div className="textWrap">
          {locationText1 && (
            <HeadLines
              className={`padding-left4 textWrap ${
                fontChange
                  ? "line-height19 letterSpacing05 font-size16"
                  : isMobile
                  ? "line-height14 letterSpacing025 font-size12"
                  : "line-height16 letterSpacing05 font-size14"
              } font-weight400 colorDark9  ${locationText1ClassName}`}
              text={locationText1}
            />
          )}
        </div>
      </div>
      <div className="textWrap">
        {locationText2 && (
          <HeadLines
            className={`padding textWrap ${styles["margin-top4"]} ${
              isMobile
                ? "line-height14 letterSpacing025 font-size12"
                : "line-height16 letterSpacing05 font-size14"
            } font-weight400 colorDark9  ${locationText2ClassName}`}
            text={locationText2}
          />
        )}
      </div>
    </div>
  );
};

export default TwoLineLocationWarehouse;
